import Fetch from "utils/fetch"

export const updateStockFromSap = (model) => Fetch.post('/labeled-family-centers:update-stock-from-sap', model).then(({ data }) => data);

export const runStockProjection = (id) => Fetch.post(`/labeled-family-centers/${id}:run-stock-projection`).then(({ data }) => data);

export const generateSuggestions = (model) => Fetch.post('/labeled-family-centers:generate-suggestions', model).then(({ data }) => data);

export const getLabeledFamilyCenterById = (id) => Fetch.get(`/labeled-family-centers/${id}`).then(({ data }) => data);
